module.exports = "<a class=\"linkButton\"\r\n        ng-if=\"$ctrl.orderCount > 0\"\r\n        ui-sref=\"shop.myaccount.myorders\"\r\n        wow-event-recorder=\"click\"\r\n        data-er-category=\"Active Orders\"\r\n        data-er-label=\"You have x open orders\">\r\n    <span class=\"cartOrderManagement-linkText u-flexCenter\">\r\n        You have {{::$ctrl.orderCount}} open&nbsp;\r\n        <ng-pluralize\r\n            count=\"::$ctrl.orderCount\"\r\n            when=\"{'1': 'order', 'other': 'orders'}\">\r\n        </ng-pluralize>\r\n    </span>\r\n</a>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shop/cart/cart-order-management.component.html
// module id = 157
// module chunks = 0 2